const AmazonCognitoIdentity = window.AmazonCognitoIdentity;

/*
* Cognito User Pool functions
*/
const poolData = {
  UserPoolId: window.CONFIG.COGNITO.userPoolId,
  ClientId: window.CONFIG.COGNITO.userPoolClientId
};

const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

export const register = (email, password, onSuccess, onFailure) => {
  let dataEmail = {
      Name: 'email',
      Value: email
  };
  let attributeEmail = new AmazonCognitoIdentity.CognitoUserAttribute(dataEmail);

  userPool.signUp(email, password, [attributeEmail], null,
      function signUpCallback(err, result) {
          if (!err) {
              onSuccess(result);
          } else {
              onFailure(err);
          }
      }
  );
}

export const signin = (email, password, onSuccess, onFailure) => {
    let authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails({
        Username: email,
        Password: password
    });

    let cognitoUser = createCognitoUser(email);
    cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: onSuccess,
        onFailure: onFailure
    });
}

export const verify = (email, code, onSuccess, onFailure) => {
    createCognitoUser(email).confirmRegistration(code, true, function confirmCallback(err, result) {
        if (!err) {
            onSuccess(result);
        } else {
            onFailure(err);
        }
    });
}

function createCognitoUser(email) {
    return new AmazonCognitoIdentity.CognitoUser({
        Username: email,
        Pool: userPool
    });
}
  
export const changePassword = (email, oldPassword, newPassword, onSuccess, onFailure) => {
    let cognitoUser = userPool.getCurrentUser();

    if (cognitoUser != null) {
        cognitoUser.getSession(function (err, session) {
            if (err) {
                alert(err);
                return;
            }
            cognitoUser.changePassword(oldPassword, newPassword, function changeCallback(err, result) {
                if (!err) {
                    onSuccess(result);
                } else {
                    onFailure(err);
                }
            });
        });
    }
}

export const forgotPassword = (email, onConfirmCallBack, reject) => {
    let cognitoUser = createCognitoUser(email);

    cognitoUser.forgotPassword({
        onSuccess: function () {
            console.log('forgot Password done.');
        },
        onFailure: function(err) {
            reject(err);
        },
        inputVerificationCode() {
            if (onConfirmCallBack && typeof onConfirmCallBack === 'function') {
                onConfirmCallBack(cognitoUser);
            } else {
                let verificationCode = prompt('Please input verification code ' ,'');
                let newPassword = prompt('Enter new password ' ,'');
                cognitoUser.confirmPassword(verificationCode, newPassword, this);
            }
        }
    });
}